import type {PaletteMode} from '@mui/material';

export const getPlaceholderOpacity = (mode: PaletteMode = 'light') => {
	// We need to get better contrast for accessibility
	// 0.618 gets us the exact color that the browser placeholder default color is
	// increaased the dark by .05 as well
	return {opacity: mode === 'light' ? 0.618 : 0.55};
};
